<div class="custom-box"  > 
  <section class="" *ngIf="color === 'pur'" >
      
    <!---first row start here-->
    <div class="r ow">
    <div class="col-lg-12 mySlides whats-new-section"   >
      
      
      <div class="" >
        <div class="slidebuttonprev " title="prev" > <button  (click)="prev()">&#10094;</button>
        </div>

        <div class="w-100">
           <div class="card solution_card " *ngFor="let whatsNewLoop of whatsNewData;">
       
        
          <p class="custom-scroll-bar" *ngIf="usedLanguage === 'hi' && (whatsNewLoop.titleHi !== '' || whatsNewLoop.titleHi !== null) &&  whatsNewLoop.titleHi!=null && whatsNewLoop.titleHi!=''" >{{whatsNewLoop.titleHi}}
            
            <span *ngFor="let pdflist of PdfDataList">
              <a *ngIf="whatsNewLoop.id == pdflist.content?.id && pdflist.filePathEn!==null"
                      [routerLink]=""
                      (click)="ViewPdf(pdflist.filePathHi)">
                      &nbsp;<span class="pdf-icon"></span>
                  </a>
              </span>
  
          </p>
          
          <p class="custom-scroll-bar" *ngIf="usedLanguage === 'hi' && (whatsNewLoop.titleHi == '' || whatsNewLoop.titleHi == null)" >{{whatsNewLoop.titleEn}}
            <span *ngFor="let pdflist of PdfDataList">
              <a *ngIf="whatsNewLoop.id == pdflist.content?.id && pdflist.filePathEn!==null"
                      [routerLink]=""
                      (click)="ViewPdf(pdflist.filePathEn)">
                      &nbsp;<span class="pdf-icon"></span>
                  </a>
              </span>
          </p>
          <p class="custom-scroll-bar" *ngIf="usedLanguage === 'en' " >{{whatsNewLoop.titleEn}}
            <span *ngFor="let pdflist of PdfDataList">
              <a *ngIf="whatsNewLoop.id == pdflist.content?.id && pdflist.filePathEn!==null"
                      [routerLink]=""
                      (click)="ViewPdf(pdflist.filePathEn)">
                      &nbsp;<span class="pdf-icon"></span>
                  </a>
              </span>
          </p>
          <!-- <p class="custom-scroll-bar" >{{whatsNewLoop.titleEn}}</p> -->
          <span class="date-time-stamp">{{whatsNewLoop.publishDt|date: 'dd-MMM-yyyy':'UTC'}}</span>
        </div></div>
        
      <div class="slidebuttonnext" title="next" > <button (click)="next()" >&#10095;</button></div>
    </div>
  

         
      
   </div>
  </div>
 
  </section>


  <section class="gst-section-black" *ngIf="color === 'bule'" >
      
    <!---first row start here-->
    <div class="row">
    <div class="col-lg-12 mySlides whats-new-section"   >
      
      
      <div class="float-start col-xs-8 col-md-8 col-lg-10 full-width position-relative" >
        <div class="float-start col-xs-2 col-md-2 col-lg-1  align-items-center slidebuttonprev " > <button  (click)="prev()">&#10094;</button></div>
        <div class="col-xs-12 col-md-4 col-lg-4 card solution_card " *ngFor="let whatsNewLoop of whatsNewData;">
       
        
        <p class="custom-scroll-bar" *ngIf="usedLanguage === 'hi' && (whatsNewLoop.titleHi !== '' || whatsNewLoop.titleHi !== null) &&  whatsNewLoop.titleHi!=null && whatsNewLoop.titleHi!=''" >{{whatsNewLoop.titleHi}}
          
          <span *ngFor="let pdflist of PdfDataList">
            <a *ngIf="whatsNewLoop.id == pdflist.content?.id && pdflist.filePathEn!==null"
                    [routerLink]=""
                    (click)="ViewPdf(pdflist.filePathHi)">
                    &nbsp;<span class="pdf-icon"></span>
                </a>
            </span>

        </p>
        
        <p class="custom-scroll-bar" *ngIf="usedLanguage === 'hi' && (whatsNewLoop.titleHi == '' || whatsNewLoop.titleHi == null)" >{{whatsNewLoop.titleEn}}
          <span *ngFor="let pdflist of PdfDataList">
            <a *ngIf="whatsNewLoop.id == pdflist.content?.id && pdflist.filePathEn!==null"
                    [routerLink]=""
                    (click)="ViewPdf(pdflist.filePathEn)">
                    &nbsp;<span class="pdf-icon"></span>
                </a>
            </span>
        </p>
        <p class="custom-scroll-bar" *ngIf="usedLanguage === 'en' " >{{whatsNewLoop.titleEn}}
          <span *ngFor="let pdflist of PdfDataList">
            <a *ngIf="whatsNewLoop.id == pdflist.content?.id && pdflist.filePathEn!==null"
                    [routerLink]=""
                    (click)="ViewPdf(pdflist.filePathEn)">
                    &nbsp;<span class="pdf-icon"></span>
                </a>
            </span>
        </p>
        <!-- <p class="custom-scroll-bar" >{{whatsNewLoop.titleEn}}</p> -->
        <span class="date-time-stamp">{{whatsNewLoop.publishDt|date: 'dd-MMM-yyyy':'UTC'}}</span>
      </div>
      <div class="float-end col-xs-2 col-md-2 col-lg-1  align-items-center slidebuttonnext" > <button (click)="next()" >&#10095;</button></div>
    </div>
  

         
      
   </div>
  </div>
 
  </section>


 
</div>
